export const DRAWER_WIDTH = 256;
